module.exports = __webpack_public_path__ + "img/pix.b78218c6.svg";